module.exports = "<alert-ui></alert-ui>\n<router-outlet></router-outlet>\n<p class=\"appVersion\">{{appVersion}}</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/lora-root.template.html
// module id = ../../../../../src/app/lora-root.template.html
// module chunks = main